<template>
    <el-dialog
        :visible="visible"
        :append-to-body="true"
        title="Import Products"
        @close="$emit('close')"
    >
        <div class="upload-form">
            <el-form v-show="!finished && !uploading">
                <el-form-item v-if="requireSelectSupplier" prop="supplierId">
                    <supplier-search
                        :selected-supplier="selectedSupplier"
                        @selected:supplier="handleSelectSupplier"
                    >
                    </supplier-search>
                </el-form-item>
                <el-upload
                    v-if="hasSelectedSupplier"
                    :action="url"
                    :headers="headers"
                    :on-success="success"
                    :on-progress="progress"
                    :before-upload="before"
                    class="upload-demo"
                    drag
                    name="products"
                    accept="csv"
                >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        Drop file here or <em>click to upload</em>
                    </div>
                    <div slot="tip" class="el-upload__tip">
                        <a
                            style="color: #409EFF"
                            href="/example-global-products-import.csv"
                            target="_blank"
                            @click.native="$event.stopPropagation()"
                            >Click Here</a
                        >
                        to download the
                        <a
                            href="example-global-products-import.csv"
                            target="_blank"
                            >example CSV file</a
                        >.
                    </div>
                </el-upload>
            </el-form>
            <div v-show="uploading">
                <h3>Uploading File...</h3>
            </div>
            <div v-show="finished">
                <h3>Upload Finished. Imported {{ count }} products.</h3>
            </div>
        </div>
        <div slot="footer">
            <el-button @click="$emit('close')">Close</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { baseURL, AUTH_TOKEN } from "Repositories/apiRepository";
import SupplierSearch from "Components/SupplierSearch";

export default {
    components: {
        SupplierSearch,
    },

    props: {
        visible: Boolean,
        supplierId: {
            type: String,
            default: "",
        },
    },

    data: () => ({
        fileList: [],
        finished: false,
        uploading: false,
        count: 0,
        publicPath: process.env.BASE_URL,
        selectedSupplier: {},
    }),

    computed: {
        requireSelectSupplier() {
            return (
                this.supplierId === "" ||
                !this.supplierId ||
                this.supplierId === "-"
            );
        },

        hasSelectedSupplier() {
            if (!this.requireSelectSupplier) {
                return true;
            }

            // eslint-disable-next-line no-underscore-dangle
            return !!this.selectedSupplier._id;
        },

        url() {
            if (this.requireSelectSupplier) {
                return `${baseURL}/suppliers/${
                    this.selectedSupplier._id
                }/products/import`;
            }

            return `${baseURL}/suppliers/${this.supplierId}/products/import`;
        },

        headers() {
            return {
                Authorization: `Bearer ${AUTH_TOKEN}`,
            };
        },
    },

    methods: {
        success(response) {
            this.finished = true;
            this.uploading = false;
            this.count = response.data.length;
            this.$emit("upload:complete");
        },

        before() {
            this.uploading = true;
        },

        progress() {},

        handleSelectSupplier(selectedSupplier) {
            console.log("handling select supplier", selectedSupplier);
            this.selectedSupplier = selectedSupplier;
        },
    },
};
</script>

<style scoped lang="scss">
.upload-form {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
}
</style>
